import { DateHelper } from '../util/dateHelper';
import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Deserializable } from './deserializable';
import { TimeSlot } from './timeSlot';


export class GroupPermissions implements Deserializable {
  id: number;
  groupId: number;
  serial: string;

  creatorUid: string;

  String: string;

  startDate: string;
  expirationDate: string;
  usedDate: Date;
  timeSlots: TimeSlot[];

  dayMask: number;
  timeMask: string;
  timeZone: string;

  startDateDate: Date;
  expirationDateDate: Date;

  expiredPermissions: boolean = false;

  deserialize(input: any) {

    Object.assign(this, input);

    this.startDateDate = new Date(this.startDate);
    this.expirationDateDate = new Date(this.expirationDate);

    this.timeSlots = TimeSlotHelper.binaryStringToTimeSlots(this.timeMask);

    return this;
  }

  isDayAllowed(dayOfWeek: number) {
    dayOfWeek = dayOfWeek - 1;

    return (this.dayMask & (1 << dayOfWeek)) == (1 << dayOfWeek);
  }

  getDayCheckedOrNot(dayOfWeek: number) {

    if (this.isDayAllowed(dayOfWeek)) {
      return "true";
    }
    else {
      return "false";
    }
  }

  getShortDescription() {
    this.expirationDateDate.setHours(23);
    this.expirationDateDate.setMinutes(59);
    if (this.expirationDateDate.getTime() < new Date().getTime()) {
      this.expiredPermissions = true;
      return $localize`:@@user_permission_expiredpermissions):I permessi sono scaduti`;
    } else {
      this.expiredPermissions = false;
      let daysAllowed: string = "";
      if (this.dayMask == 127) {
        daysAllowed = $localize`:@@group_permission_everyday:, Tutti i giorni `;
      } else if (this.isDayAllowed(1) && this.isDayAllowed(2) && this.isDayAllowed(3) && this.isDayAllowed(4) && this.isDayAllowed(5) && !this.isDayAllowed(6) && !this.isDayAllowed(7)) {
        daysAllowed = $localize`:@@group_permission_working_days: , Giorni lavorativi (lun-ver) `;
      } else {
        if (this.isDayAllowed(1)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_monday_short: , lun`;
        }
        if (this.isDayAllowed(2)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_tuesday_short: , mar`;
        }
        if (this.isDayAllowed(3)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_wednesday_short: , mer`;
        }
        if (this.isDayAllowed(4)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_thursday_short: , gio`;
        }
        if (this.isDayAllowed(5)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_friday_short: , ven`;
        }
        if (this.isDayAllowed(6)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_saturday_short: , sab`;
        }
        if (this.isDayAllowed(7)) {
          daysAllowed = daysAllowed + $localize`:@@group_permission_sunday_short: , sab`;
        }
      }


      let hoursAllowed: string = "";
      if (this.timeSlots.length == 0) {
        hoursAllowed = $localize`:@@group_permission_all_day:, Tutto il giorno`;
      } else {
        for (let i = 0; i < this.timeSlots.length; i++) {
          hoursAllowed = hoursAllowed + $localize`:@@group_permission_time_from: , dalle` + " " + this.timeSlots[i].getFromHourMin() + $localize`:@@group_permission_time_to: , alle` + " " + this.timeSlots[i].getToHourMin();
        }
      }
      return $localize`:@@group_permission_days_from:Dal` + " " + DateHelper.formatShortDateFriendly(this.startDateDate) + " " + $localize`:@@group_permission_days_to: al` + " " + DateHelper.formatShortDateFriendly(this.expirationDateDate) + daysAllowed + hoursAllowed;;
    }
  }
}
